import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, FormGroup } from 'react-bootstrap';
import { Heading, FormBox } from '../../StyledComponents/StyledComponents';
import ComponentHelper from '../../../helpers/ComponentHelper';

class Company extends Component {
  handleAddressChange = (fieldName, address) => {
    const { updateAddress } = this.props;
    updateAddress(address, fieldName);
  };

  render() {
    const { content, formValues, form } = this.props;
    return (
      <>
        {content && (
          <>
            <FormGroup>
              <Col sm={12}>
                <Heading>Agency - Company Information</Heading>
              </Col>
            </FormGroup>
            <FormBox>
              <ComponentHelper
                contentFields={content.fields}
                formValues={formValues}
                labelSize={3}
                colSize={9}
                form={form}
                updateAddress={this.handleAddressChange}
              />
            </FormBox>
          </>
        )}
      </>
    );
  }
}

export default connect(() => {
  return {
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  };
})(Company);
